module.exports = __webpack_public_path__ + "static/logo-c9a4cf02bc00bdbbc1d1013f1f88ce25.png";